export default __webpack_public_path__ + "static/media/brand7.a05fa89c.png";